import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-bluetooth',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Bluetooth icon</title><path d="M12 0C6.76 0 3.1484 2.4895 3.1484 12S6.76 24 12 24c5.24 0 8.8516-2.4895 8.8516-12S17.24 0 12 0zm-.7773 1.6816l6.2148 6.2149L13.334 12l4.1035 4.1035-6.2148 6.2149V14.125l-3.418 3.42-1.2422-1.2442L10.8515 12l-4.289-4.3008 1.2422-1.2441 3.418 3.4199V1.6816zm1.748 4.2442v3.9687l1.9844-1.9843-1.9844-1.9844zm0 8.1816v3.9668l1.9844-1.9844-1.9844-1.9824Z"/></svg>`,
    styles: []
})
export class SimpleIconsBluetoothComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#0082FC';
    @Input() className: string = 'simple-icons-bluetooth'
    constructor() {}
    ngOnInit(): void {}
}
